import React, { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RichTextEditor } from 'components/atoms/rich-text-editor';
import styles from 'components/organisms/templates/commons/cke.module.css';
import {
  ProjectTemplateTask,
  ProjectTemplateProjectPhase,
  setProjectTemplateActiveRecord,
  useGetAllTasks,
  useGetAllProjectPhases,
} from 'data/templates/projects';
import { Breadcrumb, BreadcrumbButton } from '../../../../commons/task/styles';

type TaskObject = {
  id: number;
  name: string;
  type: 'PROJECT_PHASE' | 'TASK';
};

const constructTree = (
  allPhases: { [key: string]: ProjectTemplateProjectPhase },
  tasks: { [key: string]: ProjectTemplateTask },
  currentTaskId: number,
  breadcrumbs = [] as TaskObject[],
) => {
  const currentTask = tasks[currentTaskId];

  breadcrumbs.push({
    id: currentTask.taskId,
    name: currentTask.taskName,
    type: 'TASK',
  });

  if (currentTask.projectPhase) {
    breadcrumbs.push({
      id: currentTask.projectPhase.projectPhaseId,
      name: allPhases[currentTask.projectPhase.projectPhaseId].projectPhaseName,
      type: 'PROJECT_PHASE',
    });

    breadcrumbs.reverse().pop();

    return breadcrumbs;
  }

  return constructTree(
    allPhases,
    tasks,
    currentTask.parentTask.taskId,
    breadcrumbs,
  );
};

export const TaskDetailBreadcrumb: FC<{ taskId: number }> = ({ taskId }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<TaskObject[]>([]);
  const allTasks = useGetAllTasks();
  const allPhases = useGetAllProjectPhases();
  const dispatch = useDispatch();

  useEffect(() => {
    setBreadcrumbs(constructTree(allPhases, allTasks, taskId));
  }, [allPhases, allTasks, taskId]);

  const onClick = (props: { id: number; type: 'TASK' | 'PROJECT_PHASE' }) => {
    dispatch(setProjectTemplateActiveRecord(props));
  };

  return (
    <Breadcrumb>
      {breadcrumbs.map((breadcrumb) => (
        <Breadcrumb.Item key={breadcrumb.id}>
          <BreadcrumbButton
            title={breadcrumb.name}
            onClick={() => onClick(breadcrumb)}
          >
            <RichTextEditor
              data={breadcrumb.name}
              readonly
              allowSimpleVariables
              className={`${styles['template-title-input']} ${styles['breadcrumb-name']}`}
            />
          </BreadcrumbButton>
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};
